var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateUpsidedown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "123px",
    height: "99px",
    viewBox: "0 0 123 99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rotate-upsidedown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nubis",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-List---Rotation",
    transform: "translate(-621.000000, -760.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate-upsidedown",
    transform: "translate(682.500000, 803.000000) scale(-1, 1) translate(-682.500000, -803.000000) translate(624.000000, 750.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeOpacity: 0.38833042,
    stroke: "#979797",
    strokeWidth: 5,
    x: 0,
    y: 0,
    width: 80,
    height: 56,
    rx: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 52,
    x2: 79,
    y2: 52,
    id: "Path",
    stroke: "#D7D7D7",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(77.000000, 60.000000) scale(1, -1) translate(-77.000000, -60.000000) translate(37.000000, 32.000000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 5,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 80,
    height: 56,
    rx: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 52,
    x2: 79,
    y2: 52,
    id: "Path",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic-outline-screen-rotation",
    transform: "translate(37.000000, 21.500000) rotate(20.000000) translate(-37.000000, -21.500000) translate(19.000000, 6.000000)",
    fill: "#979797",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8254545,7.10181818 C24.0409091,11.47 30.6354545,20.4036364 31.65,31 L35.8772727,31 C34.44,13.64 19.9263636,0 2.2,0 L0.34,0.0845454545 L11.0772727,10.8218182 L14.8254545,7.10181818 Z",
    id: "Icon-Shape",
    transform: "translate(18.108636, 15.500000) scale(1, -1) rotate(-180.000000) translate(-18.108636, -15.500000) "
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateUpsidedown);
export default __webpack_public_path__ + "static/media/rotate-upsidedown.1c51ecf2829784d39ef5d1f7e1f0de7c.svg";
export { ForwardRef as ReactComponent };